export const getDateMMYY = (date: Date | string) => {
  const yearLen = 2;
  const monthAdd = 1;

  date = new Date(date);

  let year = date.getFullYear().toString();

  year = year.substring(yearLen, year.length);

  let month = (monthAdd + date.getMonth()).toString();

  month = month.length > monthAdd ? month : `0${month}`;

  return `${month}/${year}`;
};

export const getDateLong = (date: string | Date) => {
  return new Date(date).toLocaleString('default', { month: 'long', day: '2-digit', year: 'numeric' });
};
